import { type IRawTiledMap, validateRawTiledMap } from '@nova/types';

import { axiosHttp } from '../axios-http';

import { MAP_ASSET_REMOTE_PROD_HOST, MAP_ASSET_REMOTE_PROD_PATH } from './map-asset-urls';

export interface DownloadMapTiledJsonParams {
  assetName: string;
  /** Base URL for dev maps (e.g. `playerDebugSettingsGES.devMapsAssetPath`); trailing slash optional. */
  devMapsAssetPath?: string;
}

/**
 * Fetches Tiled map JSON from a dev base URL or the production CDN.
 * Hosts may skip this when they pass `preloadedMapData` into `createAuthoritativeMatch`.
 */
export async function downloadMapTiledJson(params: DownloadMapTiledJsonParams): Promise<IRawTiledMap> {
  const { assetName, devMapsAssetPath } = params;
  if (devMapsAssetPath) {
    const base = devMapsAssetPath.endsWith('/') ? devMapsAssetPath : `${devMapsAssetPath}/`;
    const { data } = await axiosHttp.get<unknown>(`${base}${assetName}.json`);
    return validateRawTiledMap(data);
  }
  const url = `${MAP_ASSET_REMOTE_PROD_HOST}/${MAP_ASSET_REMOTE_PROD_PATH}/${assetName}.json`;
  const { data } = await axiosHttp.get<unknown>(url);
  return validateRawTiledMap(data);
}
